/**
 * Support URL registry.
 *
 * Each article points at its canonical HubSpot support URL.
 * If a specific article is not yet available, callers fall back to the
 * documentation home page.
 */

const SUPPORT_ARTICLES = {
  documentation: {
    hubspot: 'https://support.leanlaw.co/'
  },
  conflictCheck: {
    hubspot: 'https://support.leanlaw.co/leanlaw-conflict-check'
  },
  trustDisburse: {
    hubspot: 'https://support.leanlaw.co/leanlaw-disburse-trust-funds'
  },
  reportsOverview: {
    hubspot: 'https://support.leanlaw.co/leanlaw-reports-overview'
  },
  trustPayeeSetup: {
    hubspot: 'https://support.leanlaw.co/leanlaw-trust-payee-setup'
  },
  emailServiceSetup: {
    hubspot: 'https://support.leanlaw.co/leanlaw-invoice-email-setup'
  },
  duplicateInvoiceNumbers: {
    hubspot: 'https://support.leanlaw.co/leanlaw-voiding-adjusting-invoices'
  },
  expenseAttachments: {
    hubspot: 'https://support.leanlaw.co/leanlaw-expense-attachments'
  },
  emailTracking: {
    hubspot: 'https://support.leanlaw.co/leanlaw-email-tracking'
  },
  m365CalendarIntegration: {
    hubspot: 'https://support.leanlaw.co/leanlaw-microsoft-365-calendar'
  },
  splitBilling: {
    hubspot: 'https://support.leanlaw.co/leanlaw-split-billing'
  },
  ledesBilling: {
    hubspot: 'https://support.leanlaw.co/leanlaw-ledes-firm-settings'
  },
  revenueReports: {
    hubspot: 'https://support.leanlaw.co/leanlaw-revenue-reports'
  },
  qboIntegration: {
    hubspot: 'https://support.leanlaw.co/leanlaw-connect-quickbooks-online'
  },
  matterBillingTypes: {
    hubspot: 'https://support.leanlaw.co/matter-billing-types'
  },
  invoiceWorkflows: {
    hubspot: 'https://support.leanlaw.co/leanlaw-invoice-workflows'
  },
  gettingStarted: {
    hubspot: 'https://support.leanlaw.co/getting-started'
  },
  mattersPageUpgrade: {
    hubspot: 'https://support.leanlaw.co/the-matters-page-has-been-upgraded'
  }
};

/**
 * Look up a full support URL by key.
 *
 * Returns the HubSpot URL when available, otherwise the documentation
 * home page.
 *
 * @param {string} key Key from SUPPORT_ARTICLES
 * @returns {string} Full URL that is known to work
 */
export function getSupportArticleUrl(key) {
  const article = SUPPORT_ARTICLES[key];
  if (!article || !article.hubspot) return SUPPORT_ARTICLES.documentation.hubspot;
  return article.hubspot;
}
export { SUPPORT_ARTICLES };